import { httpsCallable } from 'firebase/functions';
import type {
  PromoInterestConfigUpsertRequest,
  PromoInterestConfigUpsertResponse,
} from '@kawai/shared';
import { functions } from '../firebase.js';

/**
 * M-62 (promo): 興味タグ設定 保存 Callable のクライアント側ラッパ。
 *
 * `promoInterestConfigUpsert`: doc id = tenantId の 1 doc を冪等 upsert し、保存後に過去ログから
 * 全顧客の興味タグを再集計する。Functions 側で zod 検証 / role + features('promo') / tenantId 強制 /
 * audit_logs / 再集計を行うため、ここでは呼ぶだけ。戻り値に再集計件数を含む。
 */
const callable = httpsCallable<
  PromoInterestConfigUpsertRequest,
  PromoInterestConfigUpsertResponse
>(functions, 'promoInterestConfigUpsert');

/** 興味タグ設定を保存し、全件再集計する。戻り値に usersUpdated / usersCleared を含む。 */
export async function callPromoInterestConfigUpsert(
  req: PromoInterestConfigUpsertRequest,
): Promise<PromoInterestConfigUpsertResponse> {
  const res = await callable(req);
  return res.data;
}
